import React, { memo } from 'react';
import { useLocale } from '@redlink/assets/locale';
import { RadioButtonGroup } from '@redlink/components/muscles';

export const CategoryItems = memo(
  ({ data, onSelectItem, onDeletePress, onEditPress, selectedItem = null }) => {
    const { dictionary } = useLocale();

    const onChangeItem = (item, index) => {
      onSelectItem(item, index);
    };

    const onEditItem = (item, index) => {
      onEditPress(item, index);
    };

    return (
      <>
        <RadioButtonGroup
          isSelected={selectedItem === null}
          item={{ title: dictionary.withoutCategory }}
          onSelectItem={() => onChangeItem(null, 0)}
          withAction={false}
        />
        {data.map((item, index) => {
          const isSelected = item.id === selectedItem?.id;
          return (
            <RadioButtonGroup
              key={index}
              {...{ item, isSelected }}
              onSelectItem={() => onChangeItem(item, index + 1)}
              onDeletePress={() => onDeletePress(item, index + 1)}
              onEditPress={() => onEditItem(item, index + 1)}
            />
          );
        })}
      </>
    );
  }
);
